export var Types;
(function (Types) {
    Types["UPDATE_CHANNEL_ID"] = "UPDATE_CHANNEL_ID";
    Types["UPDATE_CHANNEL"] = "UPDATE_CHANNEL";
    Types["RETRY_FETCH"] = "RETRY_FETCH";
})(Types || (Types = {}));
//# sourceMappingURL=ChannelActions.js.map